<script lang="ts" setup>
import { computed, inject } from 'vue'

import { type ApiReferenceConfiguration } from '@scalar-org/api-reference-pro'

// @ts-expect-error dynamic import names
import { data } from '@/assets/UDOWgkMSPIQ1atzWSLMQ8.js'
import { useSidebarState } from '@/hooks'
import Reference from '@/views/references/Reference.vue'
import { type PublishReferenceProps } from '@/views/references/types'

const props = defineProps<PublishReferenceProps>()

const { sidebarState } = useSidebarState()

const proxyUrl = inject('proxyUrl') as string

if (!proxyUrl) console.error('Proxy is not injected')

function parseConfig(config?: string) {
  try {
    return JSON.parse(config ?? '{}')
  } catch (error) {
    console.log(error)
    return {}
  }
}

/** Custom config parsed from the user provided reference config */
const configuration = computed((): ApiReferenceConfiguration => {
  const reference = props.version.references[props.referenceUid]

  const customConfig = parseConfig(reference.config)

  return {
    proxyUrl,
    showSidebar: sidebarState.showSidebar,
    hideSearch: true,
    content: data.content,
    ...customConfig,
  }
})
</script>

<template>
  <Reference
    v-bind="props"
    :configuration
    :parsed="<any>data.parsed"
    :raw="data.content" />
</template>
